<!--  -->
<template>
  <div>
    <div class="widget-cate">{{title}}</div>
    <Draggable
      tag="ul"
      item-key="type"
      ghostClass="ghost"
      :group="{name: 'people',pull: 'clone', put: false}"
      :sort="false"
      :list="list"
      :disabled="disabled"
      @choose="groupChange"
    >
      <template #item="{element}">
        <ol>
          <li
            v-if="fields.includes(element.type)"
            class="form-edit-widget-label"
            :key="element.type"
            :class="{ 'no-put': element.tpye === 'divider' }"
          >
            <a-tag color="#55acee" class="groupTag">
              <template #icon>
                <Icon :icon="element.icon" />
              </template>
              <span>{{ element.label }}</span>
            </a-tag>
          </li>
        </ol>
      </template>
    </Draggable>
  </div>
</template>

<script>
import Draggable from "vuedraggable";
import { defineComponent } from "vue";
import Icon from "@/layout/icon";
// 导入的其他文件 例如：import moduleName from 'modulePath';
export default defineComponent({
  name: "ComponentGroup",
  components: {
    Draggable,
    Icon
  },
  props: {
    title: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean
    }
  },
  setup(props, { attrs, slots, emit }) {
    const groupChange = e => {
      emit("groupChange", e);
    };
    return {
      groupChange
    };
  }
});
</script>
<style lang='less' scoped>
ol {
  margin: 0;
  padding: 0;
}
//@import url(); 引入公共css类
.widget-cate {
  padding: 0 10px 10px;
  font-weight: 600;
  #flex-box.row-n-start();
}
ul {
  position: relative;
  overflow: hidden;
  padding: 0 10px 10px;
  margin: 0;
  #flex-box.row-wrap();
  width: 230px;
}
ol {
  width: 100px;
}
.form-edit-widget-label {
  font-size: 12px;
  display: block;
  width: 100%;
  line-height: 26px;
  position: relative;
  float: left;
  left: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 1%;
  border: 1px solid #f4f6fc;
  a {
    color: #333;
    display: block;
    cursor: move;
    background: #f4f6fc;
    border: 1px solid #f4f6fc;
  }
  a:hover {
    color: #409eff;
  }
}
.form-edit-widget-label:hover {
  border: 1px dashed #409eff;
}
.groupTag {
  width: 100%;
  height: 32px;
  #flex-box.row-start-c();
  span {
    padding-left: 5px;
  }
}
</style>